import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
